import colors from '../globals/colors';
var sort = {
  border: colors.secondary.darken,
  colors: {
    white: 'white',
    black84: colors.grey84
  },
  inactive: {
    background: "#FFFFFF",
    color: colors.secondary.darken,
    hover: {
      background: "#FFFFFF",
      color: colors.secondary.darken
    }
  },
  active: {
    background: colors.secondary.darken,
    color: "white",
    hover: {
      background: colors.secondary.darken,
      color: "white"
    }
  }
};
export default sort;